<!-- Start Inner Banner -->
<div class="inner-banner inner-bg7">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Maintenance Services</h3>
            <ul>
                <li><a routerLink="/services">Services</a></li>
                <li><i class='bx bxs-chevron-right'></i></li>
                <li>Maintenance Services</li>
            </ul>
        </div>
    </div>
</div>
<!-- Inner Banner End -->

<!-- Start Services Details Area -->
<div class="service-details-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="service-article">
                    <div class="service-article-img">
                        <img src="assets/img/services/details/maintenance-details.jpg" alt="Images">
                    </div>

                    <div class="service-article-content">
                        <h2>Maintenance Services</h2>
                        <p>
                            Maintenance services encompass a range of tasks aimed at ensuring the safe and efficient operation of vehicles. 
                            These services are essential for prolonging the lifespan of a vehicle and enhancing its performance. 
                            Maintenance services can be classified into two main categories: minor maintenance services and major maintenance services.
                        </p>
                    </div>

                    <div class="service-article-list">
                        <h2>Minor Maintenance Service Tasks</h2>
                        <p>These tasks are typically performed more frequently and focus on basic upkeep to ensure the vehicle operates efficiently.</p>
                        <ul>
                            <li><i class='bx bx-check-circle'></i> Oil Change</li>
                            <li><i class='bx bx-check-circle'></i> Fluid Checks</li>
                            <li><i class='bx bx-check-circle'></i> Tire Maintenance</li>
                            <li><i class='bx bx-check-circle'></i> Battery Inspection</li>
                            <li><i class='bx bx-check-circle'></i> Air Filter Replacement</li>
                            <li><i class='bx bx-check-circle'></i> Wiper Blade Replacement</li>
                            <li><i class='bx bx-check-circle'></i> Brake Inspection</li>
                            <li><i class='bx bx-check-circle'></i> Belt and Hose Inspection</li>
                            <li><i class='bx bx-check-circle'></i> Light Inspection</li>
                        </ul>
                    </div>

                    <div class="service-article-list">
                        <h2>Full/Major Maintenance Service Tasks</h2>
                        <p>These tasks are more comprehensive and are usually performed less frequently, often at specified mileage intervals.</p>
                        <ul>
                            <li><i class='bx bx-check-circle'></i> Comprehensive Engine Tune-Up</li>
                            <li><i class='bx bx-check-circle'></i> Full Brake Service</li>
                            <li><i class='bx bx-check-circle'></i> Transmission Service</li>
                            <li><i class='bx bx-check-circle'></i> Battery Inspection</li>
                            <li><i class='bx bx-check-circle'></i> Suspension and Steering Inspection</li>
                            <li><i class='bx bx-check-circle'></i> Exhaust System Inspection and Repair</li>
                            <li><i class='bx bx-check-circle'></i> Cooling System Maintenance</li>
                            <li><i class='bx bx-check-circle'></i> Fuel System Service</li>
                            <li><i class='bx bx-check-circle'></i> Diagnostic Check</li>
                            <li><i class='bx bx-check-circle'></i> Comprehensive Safety Inspection</li>
                            <li><i class='bx bx-check-circle'></i> Emission System Check</li>
                            <li><i class='bx bx-check-circle'></i> Detailed Inspection of Drive Train Components</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="service-details-sidebar">
                    <div class="service-details-widget">
                        <h3 class="title">All Services</h3>

                        <div class="service-details-categories">
                            <ul>
                                <li><a routerLink="/services/bodywork">Bodywork and Collision Repairs</a></li>
                                <li><a routerLink="/services/inspection">Inspection and WoF Services</a></li>
                                <li><a routerLink="/services/maintenance">Maintenance Services</a></li>
                                <li><a routerLink="/services/electrical">Electrical Services</a></li>
                                <li><a routerLink="/services/air-conditioning">Air Conditioning (AC) Services</a></li>
                                <li><a routerLink="/services/repair">Repair Services</a></li>
                                <li><a routerLink="/services/diagnostic">Diagnostic Services</a></li>
                                <li><a routerLink="/services/transmission">Transmission Services</a></li>
                                <li><a routerLink="/services/customization">Customization Services</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="service-details-widget">
                        <h3 class="title">Contact Us</h3>

                        <div class="row pt-20">
                            <div class="col-lg-12 col-md-4">
                                <div class="service-widget-card">
                                    <i class='bx bx-home-smile'></i>
                                    <div class="content">
                                        <h3>Address</h3>
                                        <p>147 Benmore Avenue, Cloverlea, </p>
                                        <span>Palmerston North 4412</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-4">
                                <div class="service-widget-card">
                                    <i class='bx bx-phone-call'></i>
                                    <div class="content">
                                        <h3>Phone</h3>
                                        <p><a href="tel:+6462137137">06 213 7137</a></p>
                                        <p><a href="tel:+642102662646">0210 266 2646</a></p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-4">
                                <div class="service-widget-card">
                                    <i class='bx bxs-envelope'></i>
                                    <div class="content">
                                        <h3>Email</h3>
                                        <p><a href="mailto:info&#64;pdautomotive.co.nz">info&#64;pdautomotive.co.nz</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="subscribe-area">
                        <span>SUBSCRIBE</span>
                        <h2>SUBSCRIBE FOR NEWSLETTER</h2>
                        <form class="subscribe-form">
                            <input type="email" class="form-control" placeholder="Email*" name="EMAIL">
                            <button class="default-btn" type="submit">SUBSCRIBE</button>
                        </form>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Services Details Area End -->
